import Logo from "../../assets/images/logo.svg";
import styles from "./UnsecuredPage.module.css";

function UnsecuredPage() {
  return (
    <div className={styles.unsecuredContainer}>
      <img className={styles.unsecuredLogo} src={Logo} alt="PMS Digitization" />
      <h2 className={styles.unsecuredTitle}>
        If you see this page, Web App link you have clicked on is under Click
        Jacking security attack.
      </h2>
      <h2 className={styles.unsecuredContent}>
        Please inform team with the reference of the application from where you
        clicked this link.
      </h2>
      <h2 className={styles.unsecuredLink}>
        Click
        <a
          href={window.self.location.href}
          title="PMS Digitization"
          target="blank"
        >
          here
        </a>
        to access WebApp safely.
      </h2>
    </div>
  );
}

export default UnsecuredPage;
